/** Portable system font families: no network or licensed font file is required. */
export const MAP_FONTS = ['sans-serif', 'serif', 'monospace'];
export const MAX_TOOLTIP_LENGTH = 500;
/** Accept complete HEX colours only; never pass arbitrary user input to CSS/SVG. */
export function parseBrandColors(value) {
    const parts = value
        .trim()
        .split(/[\s,;]+/)
        .filter(Boolean);
    if (parts.length > 8 || parts.some((part) => !/^#[\da-f]{6}$/i.test(part)))
        return null;
    return parts.map((part) => part.toUpperCase());
}
export function brandOf(document) {
    const raw = document.nodes[document.map.rootNodeId]?.metadata?.brand;
    if (typeof raw !== 'object' || raw === null || !('colors' in raw) || !('font' in raw))
        return;
    if (!Array.isArray(raw.colors) || raw.colors.some((color) => typeof color !== 'string'))
        return;
    const colors = parseBrandColors(raw.colors.join(' '));
    if (colors === null || !MAP_FONTS.includes(raw.font))
        return;
    return { colors, font: raw.font };
}
export function tooltipOf(node) {
    const value = node?.metadata?.tooltip;
    return typeof value === 'string' ? value.trim().slice(0, MAX_TOOLTIP_LENGTH) : '';
}
export function withCustomization(metadata, key, value) {
    const other = Object.fromEntries(Object.entries(metadata ?? {}).filter(([name]) => name !== key));
    return value === null || value === '' ? other : { ...other, [key]: value };
}
export function brandColor(document, depth) {
    const colors = brandOf(document)?.colors;
    return colors === undefined || colors.length === 0 ? undefined : colors[depth % colors.length];
}
//# sourceMappingURL=customization.js.map